import { environment } from "src/environments/environment";

const ALLOWED_HOSTS = new Set([
    "storagelegendimages.blob.core.windows.net",
    "kind-cliff-0e00f101e.6.azurestaticapps.net", // test-NA
    "test.legenddatabase.com", // test-EU
    "dev.legenddatabase.com", // dev-EU/dev-NA
    "ambitious-bay-09e06a903.6.azurestaticapps.net", // prod-EU
    "legenddatabase.com", // prod-NA
    "salmon-sand-0a8cd7e03.5.azurestaticapps.net", // catdad-DEV
    "white-field-07c2e641e.5.azurestaticapps.net", // catdad-PROD
    "jolly-coast-054c61a03.5.azurestaticapps.net", // catdad-TEST
    "app-admin-elemental.dev.elemental.biz", // app-elemental-DEV
    "portal.elementalna.com", // app-elemental-PROD
    "app-admin-elemental.test.elemental.biz", // app-elemental-TEST
]);
export const openBlobUrl = (url: string, blockOpener: boolean = true): Window | null => {
    try {
        const options = blockOpener ? 'noopener,noreferrer' : '';
        if(!environment.production)
             return window.open(url, "_blank", options);
    
        const parsedUrl = new URL(url);

        const isHttps = parsedUrl.protocol === "https:";
        const isAllowedHost = ALLOWED_HOSTS.has(
            parsedUrl.hostname.toLowerCase(),
        );

        if (!isHttps || !isAllowedHost) {
            console.error("Blocked untrusted blob URL:", url);
            return;
        }

        return window.open(parsedUrl.href, "_blank", options);
    } catch {
        console.error("Invalid blob URL:", url);
        return null;
    }
};